import React, { useMemo, useState } from 'react';
import {
    Drawer,
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    TextField,
    Typography,
    Box
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { matchesSearch } from 'managerialTree/utils/commonHelper';

const AllEmployeeListModal = ({
    open,
    toggleAllEmpDrawer,
    empListData,
    specificEmployee
}) => {
    // const [filteredEmpData, setFilteredEmpData] = useState(empListData);
    const [filters, setFilters] = useState({
        name: '',
        branch: '',
        department: ''
    });

    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    const filteredEmpData = useMemo(() => {
        let filteredEmp = empListData.filter((el) => {
            let name = matchesSearch(el, filters.name);
            // let name = el.firstname.toLowerCase().includes(filters.name);
            let branch = filters.branch
                ? el.branchName
                      .toLowerCase()
                      .includes(filters.branch.toLowerCase())
                : true;
            let department = filters.department
                ? el.departmentName
                      .toLowerCase()
                      .includes(filters.department.toLowerCase())
                : true;
            return name && branch && department;
        });
        return filteredEmp;
    }, [filters, empListData]);

    const theme = useTheme();

    return (
        <Drawer anchor='right' open={open} onClose={toggleAllEmpDrawer(false)}>
            <Box sx={{ width: 593, height: '100vh', display: 'flex', flexDirection: 'column' }}>
                {/* Header and Filters */}
                <Box sx={{ p: 2.5, borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper', zIndex: 1 }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Typography variant='h6'>
                            👥 Employee List{' '}
                            <span style={{ color: theme.palette.error.main }}>
                                {filteredEmpData.length}
                            </span>
                        </Typography>
                        <IconButton onClick={toggleAllEmpDrawer(false)}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                        <TextField
                            variant='outlined'
                            size='small'
                            placeholder='Search'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position='start'>
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            style={{ flexGrow: 1 }}
                            onChange={(e) =>
                                handleFilterChange('name', e.target.value)
                            }
                        />
                        <Select
                            size='small'
                            defaultValue='Branch'
                            onChange={(e) =>
                                handleFilterChange('branch', e.target.value)
                            }
                        >
                            <MenuItem value='Branch' disabled>
                                Branch
                            </MenuItem>
                            <MenuItem value='Dhanmondi'>Dhanmondi</MenuItem>
                            <MenuItem value='Uttara'>Uttara</MenuItem>
                            <MenuItem value='Chittagong'>Chittagong</MenuItem>
                        </Select>
                        <Select
                            size='small'
                            defaultValue='Department'
                            onChange={(e) =>
                                handleFilterChange('department', e.target.value)
                            }
                        >
                            <MenuItem value='Department' disabled>
                                Department
                            </MenuItem>
                            <MenuItem value='UI/UX Design'>UI UX</MenuItem>
                            <MenuItem value='Quality Assurance'>SQA</MenuItem>
                            <MenuItem value='Development'>Engineering</MenuItem>
                        </Select>
                    </div>
                </Box>

                {/* Scrollable List */}
                <Box sx={{ flexGrow: 1, overflowY: 'auto', px: 2.5, bgcolor: 'background.paper' }}>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr auto',
                            fontWeight: 'bold',
                            padding: '10px 0',
                            borderBottom: '1px solid #e0e0e0',
                            marginTop: 10
                        }}
                    >
                        <div>Name</div>
                        <div>Designation</div>
                        <div>Branch</div>
                    </div>

                    {filteredEmpData.map((emp, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr 1fr auto',
                                alignItems: 'center',
                                py: 1.25,
                                borderTop: 1,
                                borderColor: 'divider',
                                gap: 1
                            }}
                        >
                            <div>
                                {emp.firstname + ' ' + emp.middlename + ' ' + emp.lastname}
                            </div>
                            <div>{emp.designationName}</div>
                            <div>{emp.branchName}</div>
                            <IconButton onClick={() => specificEmployee(emp.email)}>
                                <VisibilityIcon fontSize='small' />
                            </IconButton>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Drawer>
    );
};

export default AllEmployeeListModal;
